module.exports = __webpack_public_path__ + "static/media/serviceplaceholder.5f53c257.svg";